import { IGradientStop } from "@longline/aqua-ui/Types";
import { FeatureCollection, GeoJsonObject } from "geojson";
import { PresetGradients } from "./ILayerTypeDefinition";

interface IReference {
  name: string;
  visible: boolean;
  geojson: FeatureCollection | null;
  properties: string[];
  // Property currently selected for color interpolation. null means none picked.
  property: string | null;
  gradient: IGradientStop[];
  opacity: number;
}

const DefaultReference: IReference = {
  name: "New reference",
  geojson: null,
  visible: true,
  properties: [],
  property: null,
  gradient: PresetGradients.Blue,
  opacity: 50
}

export { IReference, DefaultReference }
